let canvas;
let context;
let screenW;
let screenH;
let intervalId;
const stars = [];

const FPS = 30;

export const star = function (el) {
  canvas = el;
  stars.splice(0, stars.length);

  clear();

  render();
  context = canvas.getContext('2d');

  const numStar = Math.floor(canvas.clientWidth / 300) * 100;

  for (let i = 0; i < numStar; i++) {
    const x = Math.round(Math.random() * screenW);
    const y = Math.round(Math.random() * screenH);
    const length = 1 + Math.random() * 2;
    const opacity = Math.random();

    const star = new Star(x, y, length, opacity);
    stars.push(star);
  }

  intervalId = setInterval(animate, 1000 / FPS);
};

function clear() {
  removeEventListener('resize', render);
  clearInterval(intervalId);
  context?.setTransform(1, 0, 0, 1, 0, 0);
  context?.clearRect(0, 0, canvas.width, canvas.height);
}

function Star(x, y, length, opacity) {
  this.x = window.parseInt(x);
  this.y = window.parseInt(y);
  this.length = window.parseInt(length);
  this.opacity = opacity;
  this.factor = 1;
  this.increment = Math.random() * 0.03;
}

Star.prototype.draw = function (context) {
  context.rotate(Number(Math.PI) / 10);

  context.save();
  context.translate(this.x, this.y);
  if (this.opacity > 1) {
    this.factor = -1;
  } else if (this.opacity <= 0) {
    this.factor = 1;

    this.x = Math.round(Math.random() * screenW);
    this.y = Math.round(Math.random() * screenH);
  }

  this.opacity += this.increment * this.factor;

  context.beginPath();
  for (let i = 5; i > 0; i--) {
    context.lineTo(0, this.length);
    context.translate(0, this.length);
    context.rotate((Math.PI * 2) / 10);
    context.lineTo(0, -this.length);
    context.translate(0, -this.length);
    context.rotate(-((Math.PI * 6) / 10));
  }

  context.lineTo(0, this.length);
  context.closePath();

  context.fillStyle = 'rgba(255,255,200, ' + this.opacity + ')';
  context.shadowBlur = 5;
  context.shadowColor = '#ffff33';
  context.fill();

  context.restore();
};

function getScreenInfo() {
  let winWidth;
  let winHeight;

  if (window.innerWidth) {
    winWidth = window.innerWidth;
  } else if (document.body && document.body.clientWidth) {
    winWidth = document.body.clientWidth;
  }

  if (window.innerHeight) {
    winHeight = window.innerHeight;
  } else if (document.body && document.body.clientHeight) {
    winHeight = document.body.clientHeight;
  }

  if (
    document.documentElement &&
    document.documentElement.clientHeight &&
    document.documentElement.clientWidth
  ) {
    winHeight = document.documentElement.clientHeight;
    winWidth = document.documentElement.clientWidth;
  }

  return {
    winWidth: winWidth,
    winHeight: winHeight
  };
}

function render() {
  screenW = canvas.clientWidth;
  screenH = canvas.clientHeight;

  canvas.width = screenW;
  canvas.height = screenH;

  window.addEventListener('resize', render);
}

function animate() {
  context.clearRect(0, 0, screenW, screenH);
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < stars.length; i++) {
    stars[i].draw(context);
  }
}
